import {
  ADD_M2M_SERVICE_PROVIDER,
  ADD_NETWORK_PROVIDERS,
  ADD_SIM_TYPE,
  ADD_SIM_TYPE_NETWORK,
  ADD_SIM_TYPE_PROFILE,
  ADD_TESTING_AGENCY,
  EDIT_ALERT_RULE,
  GET_ALERT_RULES,
  GET_ALERT_TYPE,
  GET_AMBULANCES,
  GET_CATEGORIES,
  GET_DEVICE_PROTOCOL_PORTS,
  GET_DISTRICT,
  GET_DISTRICT_GEOFENCE,
  GET_LISTENER_TYPE,
  GET_LIVE_PORTS,
  GET_M2M_SERVICE_PROVIDER,
  GET_NETWORK_PROVIDERS,
  GET_NEWS_UPDATE,
  GET_ORGANIZATION_TYPE,
  GET_PRIORITY_TYPE,
  GET_SERVER_CONFIGURATION,
  GET_SERVER_INSTANCES,
  GET_SIM_TYPES,
  GET_SIM_TYPE_NETWORK,
  GET_SIM_TYPE_PROFILE,
  GET_SOFTWARE_NOTIFICATION,
  GET_STATE_GEOFENCE,
  GET_TESTING_AGENCIES,
  GET_TICKET_SUBJECT,
  GET_TRAUMA_CENTERS,
  SET_ALERT_TYPE_STATUS,
  SET_AMBULACE,
  SET_DEVICE_PROTOCOL_PORT,
  SET_LIVE_PORTS,
  SET_NEWS_UPDATE,
  SET_ORGANIZATION_TYPE,
  SET_READ_SOFTWARE_NOTIFICATION,
  SET_SOFTWARE_NOTIFICATION,
  SET_TICKET_SUBJECT,
  SET_TRAUMA_CENTERS,
  SOFTWARE_NOTIFICATION,
  UNREAD_SOFTWARE_NOTIFICATION,
  UPDATE_ALERT_RULE_STATUS,
  UPDATE_ALERT_TYPE_STATUS,
  UPDATE_AMBULANCE_STATUS,
  UPDATE_LISTENER_PORT_AT,
  UPDATE_LIVE_PORTS_STATUS,
  UPDATE_M2M_SERVICE_PROVIDER,
  UPDATE_M2M_SERVICE_PROVIDER_STATUS,
  UPDATE_NETWORK_PROVIDERS,
  UPDATE_NETWORK_PROVIDERS_STATUS,
  UPDATE_NEWS_UPDATE_STATUS,
  UPDATE_ORGANIZATION_TYPE_STATUS,
  UPDATE_SIM_TYPE,
  UPDATE_SIM_TYPE_NETWORK,
  UPDATE_SIM_TYPE_PROFILE,
  UPDATE_SIM_TYPE_STATUS,
  UPDATE_SIM_TYPE_STATUS_NETWORK,
  UPDATE_SIM_TYPE_STATUS_PROFILE,
  UPDATE_SOFTWARE_NOTIFICATION,
  UPDATE_TAC_PORT_STATUS,
  UPDATE_TESTING_AGENCY,
  UPDATE_TESTING_AGENCY_STATUS,
  UPDATE_TICKET_SUBJECT_STATUS,
  UPDATE_TRAUMA_CENTERS_STATUS,
} from "../actions/types";

const initialState = {
  softwareNotification: [],
  setSoftwareNotification: [],
  updateSoftwareNotification: [],
  softwareNews: [],
  networkProviders: [],
  updateNetworkProviders: [],
  addNetworkProviders: [],
  updateNetworkProvidersStatus: [],
  testingAgencies: [],
  updateTestingAgencyStatus: [],
  addTestingAgency: [],
  updateTestingAgency: [],
  alertRules: [],
  updateAlertRuleStatus: [],
  editAlertRule: [],
  organizationType: [],
  updateOrganizationTypeStatus: [],
  setOrganizationType: [],
  ticketSubject: [],
  updateTicketSubjectStatus: [],
  setTicketSubject: [],
  getPriorityType: [],
  ambulances: [],
  updateAmbulanceStatus: [],
  setAmbulance: [],
  newsUpdate: [],
  updateNewsUpdateStatus: [],
  setNewsUpdate: [],
  categories: [],
  livePorts: [],
  updateLivePortsStatus: [],
  setLivePorts: [],
  listenerType: [],
  m2mServiceProviders: [],
  addM2mServiceProvider: [],
  updateM2mServiceProvider: [],
  updateM2mServiceProviderStatus: [],
  serverConfiguration: [],
  serverInstances: [],
  setDeviceProtocolPort: [],
  getDeviceProtocolPorts: [],
  updateTacPortStatus: [],
  updateListenerPortAt: [],
  simTypes: [],
  addSimType: [],
  updateSimType: [],
  updateSimTypeStatus: [],
  simTypeProfile: [],
  simTypeNetwork: [],
  updateSimTypeStatusProfile: [],
  updateSimTypeStatusNetwork: [],
  addSimTypeProfile: [],
  addSimTypeNetwork: [],
  updateSimTypeProfile: [],
  updateSimTypeNetwork: [],
  traumaCenters: [],
  updateTraumaCenterStatus: [],
  setTraumaCenter: [],
  getDistrict: [],
  unreadNotificationData: [],
  setReadNotificationData: [],
  getDistrictGeofence: [],
};

const softwareNotificationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SOFTWARE_NOTIFICATION:
      return {
        ...state,
        softwareNotification: payload,
      };
    case SET_SOFTWARE_NOTIFICATION:
      return {
        ...state,
        setSoftwareNotification: payload,
      };
    case UPDATE_SOFTWARE_NOTIFICATION:
      return {
        ...state,
        updateSoftwareNotification: payload,
      };
    case SOFTWARE_NOTIFICATION:
      return {
        ...state,
        softwareNews: payload,
      };
    default:
      return state;
  }
};
const networkProvidersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_NETWORK_PROVIDERS:
      return {
        ...state,
        networkProviders: payload,
      };
    case ADD_NETWORK_PROVIDERS:
      return {
        ...state,
        addNetworkProviders: payload,
      };
    case UPDATE_NETWORK_PROVIDERS_STATUS:
      return {
        ...state,
        updateNetworkProvidersStatus: payload,
      };
    case UPDATE_NETWORK_PROVIDERS:
      return {
        ...state,
        updateNetworkProviders: payload,
      };
    default:
      return state;
  }
};
const testingAgenciesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TESTING_AGENCIES:
      return {
        ...state,
        testingAgencies: payload,
      };
    case ADD_TESTING_AGENCY:
      return {
        ...state,
        addTestingAgency: payload,
      };
    case UPDATE_TESTING_AGENCY_STATUS:
      return {
        ...state,
        updateTestingAgencyStatus: payload,
      };
    case UPDATE_TESTING_AGENCY:
      return {
        ...state,
        updateTestingAgency: payload,
      };
    default:
      return state;
  }
};
const alertRulesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_ALERT_RULES:
      return {
        ...state,
        alertRules: payload,
      };
    case UPDATE_ALERT_RULE_STATUS:
      return {
        ...state,
        updateAlertRuleStatus: payload,
      };
    case EDIT_ALERT_RULE:
      return {
        ...state,
        editAlertRule: payload,
      };
    default:
      return state;
  }
};
const organizationTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_ORGANIZATION_TYPE:
      return {
        ...state,
        organizationType: payload,
      };
    case UPDATE_ORGANIZATION_TYPE_STATUS:
      return {
        ...state,
        updateOrganizationTypeStatus: payload,
      };
    case SET_ORGANIZATION_TYPE:
      return {
        ...state,
        setOrganizationType: payload,
      };
    default:
      return state;
  }
};

const AlertTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_ALERT_TYPE:
      return {
        ...state,
        alertTypes: payload,
      };
    case UPDATE_ALERT_TYPE_STATUS:
      return {
        ...state,
        alertTypeStatus: payload,
      };
    case SET_ALERT_TYPE_STATUS:
      return {
        ...state,
        alertTypeAdd: payload,
      };
    default:
      return state;
  }
};
const ticketTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TICKET_SUBJECT:
      return {
        ...state,
        ticketSubject: payload,
      };
    case UPDATE_TICKET_SUBJECT_STATUS:
      return {
        ...state,
        updateTicketSubjectStatus: payload,
      };
    case SET_TICKET_SUBJECT:
      return {
        ...state,
        setTicketSubject: payload,
      };
    case GET_PRIORITY_TYPE:
      return {
        ...state,
        getPriorityType: payload,
      };
    default:
      return state;
  }
};
const getAmbulancesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_AMBULANCES:
      return {
        ...state,
        ambulances: payload,
      };
    case UPDATE_AMBULANCE_STATUS:
      return {
        ...state,
        updateAmbulanceStatus: payload,
      };
    case SET_AMBULACE:
      return {
        ...state,
        setAmbulance: payload,
      };
    default:
      return state;
  }
};
const getTraumaCentersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TRAUMA_CENTERS:
      return {
        ...state,
        traumaCenters: payload,
      };
    case UPDATE_TRAUMA_CENTERS_STATUS:
      return {
        ...state,
        updateTraumaCenterStatus: payload,
      };
    case SET_TRAUMA_CENTERS:
      return {
        ...state,
        setTraumaCenter: payload,
      };
    case GET_DISTRICT:
      return {
        ...state,
        getDistrict: payload,
      };
    default:
      return state;
  }
};
const getDistrictGeofenceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DISTRICT_GEOFENCE:
      return {
        ...state,
        getDistrictGeofence: payload,
      };
    default:
      return state;
  }
};
const getStateGeofenceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_STATE_GEOFENCE:
      return {
        ...state,
        getStateGeofence: payload,
      };
    default:
      return state;
  }
};

const getNewsUpdateReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_NEWS_UPDATE:
      return {
        ...state,
        newsUpdate: payload,
      };
    case UPDATE_NEWS_UPDATE_STATUS:
      return {
        ...state,
        updateNewsUpdateStatus: payload,
      };
    case SET_NEWS_UPDATE:
      return {
        ...state,
        setNewsUpdate: payload,
      };
    case GET_CATEGORIES:
      return {
        ...state,
        categories: payload,
      };
    default:
      return state;
  }
};
const getLivePortsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_LIVE_PORTS:
      return {
        ...state,
        livePorts: payload,
      };
    case UPDATE_LIVE_PORTS_STATUS:
      return {
        ...state,
        updateLivePortsStatus: payload,
      };
    case SET_LIVE_PORTS:
      return {
        ...state,
        setLivePorts: payload,
      };
    case GET_LISTENER_TYPE:
      return {
        ...state,
        listenerType: payload,
      };
    case GET_SERVER_CONFIGURATION:
      return {
        ...state,
        serverConfiguration: payload,
      };
    case GET_SERVER_INSTANCES:
      return {
        ...state,
        serverInstances: payload,
      };
    case SET_DEVICE_PROTOCOL_PORT:
      return {
        ...state,
        setDeviceProtocolPort: payload,
      };
    case GET_DEVICE_PROTOCOL_PORTS:
      return {
        ...state,
        getDeviceProtocolPorts: payload,
      };
    case UPDATE_TAC_PORT_STATUS:
      return {
        ...state,
        updateTacPortStatus: payload,
      };
    case UPDATE_LISTENER_PORT_AT:
      return {
        ...state,
        updateListenerPortAt: payload,
      };
    default:
      return state;
  }
};
const m2mServiceProviderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_M2M_SERVICE_PROVIDER:
      return {
        ...state,
        m2mServiceProviders: payload,
      };
    case ADD_M2M_SERVICE_PROVIDER:
      return {
        ...state,
        addM2mServiceProvider: payload,
      };
    case UPDATE_M2M_SERVICE_PROVIDER_STATUS:
      return {
        ...state,
        updateM2mServiceProviderStatus: payload,
      };
    case UPDATE_M2M_SERVICE_PROVIDER:
      return {
        ...state,
        updateM2mServiceProvider: payload,
      };
    default:
      return state;
  }
};
const simTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SIM_TYPES:
      return {
        ...state,
        simTypes: payload,
      };
    case GET_SIM_TYPE_PROFILE:
      return {
        ...state,
        simTypeProfile: payload,
      };
    case GET_SIM_TYPE_NETWORK:
      return {
        ...state,
        simTypeNetwork: payload,
      };
    case ADD_SIM_TYPE:
      return {
        ...state,
        addSimType: payload,
      };
    case ADD_SIM_TYPE_PROFILE:
      return {
        ...state,
        addSimTypeProfile: payload,
      };
    case ADD_SIM_TYPE_NETWORK:
      return {
        ...state,
        addSimTypeNetwork: payload,
      };
    case UPDATE_SIM_TYPE:
      return {
        ...state,
        updateSimType: payload,
      };
    case UPDATE_SIM_TYPE_PROFILE:
      return {
        ...state,
        updateSimTypeProfile: payload,
      };
    case UPDATE_SIM_TYPE_NETWORK:
      return {
        ...state,
        updateSimTypeNetwork: payload,
      };
    case UPDATE_SIM_TYPE_STATUS:
      return {
        ...state,
        updateSimTypeStatus: payload,
      };
    case UPDATE_SIM_TYPE_STATUS_PROFILE:
      return {
        ...state,
        updateSimTypeStatusProfile: payload,
      };
    case UPDATE_SIM_TYPE_STATUS_NETWORK:
      return {
        ...state,
        updateSimTypeStatusNetwork: payload,
      };
    default:
      return state;
  }
};
const UnreadNotificationReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case UNREAD_SOFTWARE_NOTIFICATION:
      return {
        ...state,
        unreadNotificationData: payload,
      };
    case SET_READ_SOFTWARE_NOTIFICATION:
      return {
        ...state,
        setReadNotificationData: payload,
      };
    default:
      return state;
  }
};

export {
  softwareNotificationReducer,
  networkProvidersReducer,
  testingAgenciesReducer,
  alertRulesReducer,
  organizationTypeReducer,
  ticketTypeReducer,
  getAmbulancesReducer,
  getNewsUpdateReducer,
  getLivePortsReducer,
  m2mServiceProviderReducer,
  simTypeReducer,
  getTraumaCentersReducer,
  AlertTypeReducer,
  UnreadNotificationReducer,
  getDistrictGeofenceReducer,
  getStateGeofenceReducer,
};
